<template>
  <b-container
    fluid
  >
    <b-row class="mb-4">
      <b-col
        cols="12"
      >
        <b-card
          title="Webhooks"
          class="shadow-sm"
        >
          <b-row>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="4"
              order-md="5"
            >
              <PaleCard
                label="Calls"
                variant="primary"
                :count="webhooks.calls"
                :link="{ name: 'admin.webhooks.calls' }"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="3"
              order-md="4"
            >
              <PaleCard
                label="Events"
                variant="success"
                :count="webhooks.events"
                :link="{ name: 'admin.webhooks.events' }"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="4"
              order-md="5"
            >
              <PaleCard
                label="Logs"
                variant="warning"
                :count="webhooks.logs"
                :link="{ name: 'admin.webhooks.logs' }"
                :loading="fetching"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import PaleCard from '@/components/custom/PaleCard'

export default {

  name: 'AdminDashboard',

  middleware: ['auth', 'admin'],

  components: {
    PaleCard
  },

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      webhooks: {
        calls: 0,
        events: 0,
        logs: 0
      }
    }
  },

  mounted () {
    core.index()
  }
}
</script>
